import {
	InteractionBar,
	EmailInteractionContent,
} from "@/components/molecules/interactionWorkspace";
import { InteractionType } from "@/common/types";
import { useState } from "react";

type Props = {
	sessionId: string;
	type: InteractionType;
	entryPointEmail?: string;
};

export const EmailPreviewInteractionPanel = ({
	sessionId,
	type,
	entryPointEmail,
}: Props) => {
	const [isVariableTextOpen, setIsVariableTextOpen] = useState(true);

	return (
		<>
			<InteractionBar
				type={type}
				isVariableTextOpen={isVariableTextOpen}
				setIsVariableTextOpen={setIsVariableTextOpen}
			/>

			<EmailInteractionContent
				key={sessionId}
				sessionId={sessionId}
				entryPointEmail={entryPointEmail}
				isPreview={true}
			/>
		</>
	);
};
